// frontend/src/components/Samples/Divisions.jsx

import React from 'react';
import { divisionsAPI } from '../../api/client';
import { useTranslation } from '../../context/TranslationContext';
import MasterDataManager from '../Common/MasterDataManager';

const Divisions = () => {
  const { t } = useTranslation();

  const columns = [
    {
      header: t('divisions.code', 'Division Code'),
      field: 'division_code',
      className: 'code-column'
    },
    {
      header: t('divisions.description', 'Description'),
      field: 'description'
    },
    {
      header: t('created_at', 'Created'),
      field: 'created_at',
      render: (row) => new Date(row.created_at).toLocaleDateString()
    }
  ];

  const formFields = [
    {
      name: 'divisionCode',
      label: 'divisions.code',
      type: 'text',
      required: true,
      maxLength: 20
    },
    {
      name: 'description',
      label: 'divisions.description',
      type: 'text',
      maxLength: 50
    },
    {
      name: 'notes',
      label: 'notes',
      type: 'textarea',
      rows: 3
    }
  ];

  return (
    <MasterDataManager
      title="divisions.title"
      subtitle="divisions.subtitle"
      createButtonLabel="divisions.create"
      api={divisionsAPI}
      columns={columns}
      formFields={formFields}
      idField="division_id"
      displayField="division_code"
    />
  );
};

export default Divisions;